<div class="learning-path-introduction-wrap" [ngClass]="{'open':!isClosePage,'close':isClosePage}">
  <div class="introduction-top">
    <div class="introduction-title">
      <p class="title">{{learningPathName}}:</p>
      <p class="subTitle" [innerHtml]="introductionSubTitle"></p>
    </div>
  </div>
  <div class="introduction-content">

    <div *ngFor="let item of longPicArr;let i = index">
      <p class="title">{{item.content}}</p>
      <img src="{{assetsRoute}}/picture/learningpath/introduce/{{learningPathMetaId}}-{{item.index}}.png" alt=""/>
    </div>
  </div>
  <div class="introduction-bottom">
    <div class="introduction-bottom-btn" (click)="closeLearningPathIntroduction()">
      <span *ngIf="isShowCloseBtn">开启{{learningPathName}}之旅</span>
      <span *ngIf="!isShowCloseBtn">关闭</span>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/learning-path-introduction/learning-path-introduction.component.html